import React from "react";

import AllRoutes from "./routes/Routes";

//import { configureFakeBackend } from "./helpers";


// For Default import Default.scss
import "./assets/scss/Default.scss";

// For Saas import Saas.scss
// import './assets/scss/Saas.scss';

// For Modern demo import Modern.scss
// import './assets/scss/Modern.scss';

// For Creative demo import Creative.scss
// import "./assets/scss/Creative.scss";

// For Purple demo import Purple.scss
// import './assets/scss/Purple.scss';

// For Material demo import Material.scss
// import './assets/scss/Material.scss';


// Other
import "./assets/scss/Landing.scss";
import "./assets/scss/Icons.scss";
import "react-ladda-button/dist/ladda-themeless.min.css";
import "react-toastify/dist/ReactToastify.css";
import "./components/portalFeedback/toastTheme.scss";

// configure fake backend
//configureFakeBackend();

//query client
import { QueryClient, QueryClientProvider } from "react-query";
import { ToastContainer } from "react-toastify";
import { useLocation } from "react-router-dom";
import NotificationsSocketBridge from './socket/Subscriptions';
import { APICore } from './helpers/api/apiCore';
import RouteAnalytics from './analytics/usePageTracking';
import ErrorBoundary from "./components/ErrorBoundary";

export const queryClient = new QueryClient();

const apiCore = new APICore();

// Mount the notifications/socket bridge only while authenticated. Re-checked on
// every navigation (useLocation) so it mounts right after an SPA login — with a
// token — and never fires the tokenless `/supplier-api/notification` prefetch on
// the unauthenticated login page (the source of the boot-time "Auth Fail" 404).
const AuthedNotificationsBridge = () => {
  const { pathname } = useLocation();
  // Never on the sign-in pages: a stale session there used to start the socket
  // and the notifications fetch, whose 401 sent the page back to sign-in again.
  if (pathname.startsWith("/auth/")) return null;
  if (!apiCore.isUserAuthenticated()) return null;
  return <NotificationsSocketBridge />;
};

const App = () => {

  return (
    <>
      {/* A render error used to white-screen the operator with no signal at all: this app had no boundary, so the crash was invisible to everyone including us. Counts the error CLASS only - message and stack quote record values (ANALYTICS.md B4). */}
      <ErrorBoundary>
        <QueryClientProvider client={queryClient}>
          <React.Fragment>
            {/* GA4 SPA page-view + identity tracking (inside the Router) */}
            <RouteAnalytics />

            <AllRoutes />

            {/* Real-time notifications bridge (authed-only) */}
            <AuthedNotificationsBridge />

            <ToastContainer />
          </React.Fragment>
        </QueryClientProvider>
      </ErrorBoundary>
    </>
  );
};

export default App;
